import type { MouseEvent } from 'react';

type ColumnResizeHandleProps = {
  onResizeStart: (event: MouseEvent) => void;
  label?: string;
};

export function ColumnResizeHandle({
  onResizeStart,
  label = 'Redimensionar coluna',
}: ColumnResizeHandleProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title="Arrastar para redimensionar"
      onMouseDown={onResizeStart}
      className="absolute inset-y-0 right-0 z-10 w-1.5 cursor-col-resize border-0 bg-transparent p-0 hover:bg-primary-200/60 focus:outline-none focus-visible:bg-primary-300/70"
    />
  );
}
